<template>
  <!-- 环信客服工作台 -->
  <div class="big kefu_doctor">
   <iframe :src="src" frameborder="no" border="0"></iframe>
  </div>
</template>

<script>

export default {

  data() {
    return {
    src:""
    
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    }
  },
  created() {

    this.getWorktablePcWebPageUrl();
  },
  methods: {
  
    getWorktablePcWebPageUrl() {
      this.loading = true;
      let data = {
        page: this.currentPage,
        pageNumber: this.pagesize,
      };
      this.axios
        .post("platform/Customerservice/getWorktablePcWebPageUrl", data)
        .then((res) => {
        window.open(res.data)
        // this.src = res.data
        })
        .catch(() => {
          this.loading = false;
        });
    },
  
  }
    
   
};
</script>

<style lang="scss" scoped >
iframe{
  width:98%;
  min-height: calc(100vh - 60px);
}

</style>
